import ErrorInput from "./ErrorInput";
import PropTypes from "prop-types";

export const HeadInput = ({ label, formik, html_for, datosObj }) => {
  return (
    <div className="d-flex flex-row justify-content-between pe-2">
      <label htmlFor={html_for}>{label}</label>
      {formik.errors[datosObj] !== undefined && formik.touched[datosObj] !== undefined && <ErrorInput touched={formik.touched[datosObj]?.[html_for]} error={formik.errors[datosObj]?.[html_for]} />}
    </div>
  ); 
};
 
HeadInput.propTypes = {
  label: PropTypes.string.isRequired,
  formik: PropTypes.shape({  
    errors: PropTypes.object,
    touched: PropTypes.object,
  }).isRequired,
  html_for: PropTypes.string.isRequired,
  datosObj: PropTypes.string.isRequired,
};